import React, { useEffect, useState, useCallback } from "react";
import { getDictByKind } from "../../../server/Category";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ProductsFilters from "./ProductsFilters";
import ProductsTable from "./ProductsTable";
import {
  setFilters,
  clearFilters,
  setStatusFilter,
  setBaseProducts,
} from "../../../server/ProductsFilters";
import { useProductsFilters } from "./UseProductsFilters";
import { setProducts } from "../../../server/Product";
import "./ProductsWithFilters.scss";

const ProductsWithFilters = ({openModal}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { stationId, reload } = useSelector((state) => ({
    stationId: state.user.stationId,
    reload: state.productFilters.reloed,
  }));

  const filters = useSelector((state) => state.productFilters.filters);
  const statusFilter = useSelector(
    (state) => state.productFilters.statusFilter,
  );

  const [brand, setBrand] = useState([]);
  const [subBrand, setSubBrand] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const baseProducts = useProductsFilters(stationId);

  useEffect(() => {
    getDictByKind("brand").then(setBrand);
    getDictByKind("sub-brand").then(setSubBrand);
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      navigate(`/edit-product/${selectedProduct.productId}/information`, {
        state: { from: "/admin/products" },
      });
    }
  }, [selectedProduct, navigate]);

  const availableStatuses = baseProducts?.length
    ? [
        ...new Set(
          baseProducts.map((p) => p.categories?.[0]?.productStatus).filter(Boolean),
        ),
      ]
    : [];


  const filteredProducts = baseProducts?.filter((item) => {
    const p = item.product || item;
    const matchesSearch = p.name
      ?.toLowerCase()
      .includes(filters.search?.toLowerCase() ?? "");
    const matchesStatus = statusFilter
      ? item.categories?.[0]?.productStatus === statusFilter
      : true;
    return matchesSearch && matchesStatus;
  });

  const setProductsFromFilters = useCallback(
    (prods) => dispatch(setBaseProducts(prods)),
    [dispatch],
  );

  return (
    <div className="products-page">
      <ProductsFilters
        brand={brand}
        subBrand={subBrand}
        filters={filters}
        setFilters={(payload) => dispatch(setFilters(payload))}
        setProducts={setProductsFromFilters}
        clearFilters={() => dispatch(clearFilters())}
        statusFilter={statusFilter}
        setStatusFilter={(status) => dispatch(setStatusFilter(status))}
        filteredProducts={filteredProducts}
        availableStatuses={availableStatuses}
        openModal={openModal}
      />

      {reload ? (
        <p>טוען...</p>
      ) : filteredProducts?.length ? (
        <ProductsTable
          products={filteredProducts}
          onSelect={setSelectedProduct}
        />
      ) : (
        <p>לא נמצאו מוצרים עם הקריטריונים שנבחרו</p>
      )}
    </div>
  );
};

export default ProductsWithFilters;
